import React from "react";
import {StyleSheet, Platform} from "react-native";
import {TouchableOpacity, Text, View} from "react-native";
import {useCommunityTheme} from "ubcommunity-shared/src/Theme/CommunityThemeProvider";
import {AUTH_TYPE, SSO_PROVIDER} from "./auth-ui/types";
import {useGetAuthType} from "./utils/useGetAuthType";

type Props = {
    children: React.ReactNode;
    icon?: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
};

export function SSOAuthButton({icon, children, disabled, onClick = () => {}}: Props) {
    return (
        <TouchableOpacity
            accessibilityRole="button"
            disabled={disabled}
            style={{
                ...styles.Button,
                opacity: disabled ? 0.38 : 1,
                borderColor: disabled ? "#1f1f1f1f" : "#747775",
            }}
            onPress={onClick}
        >
            <View style={styles.ButtonContentWrapper}>
                <View style={styles.Icon}>{icon}</View>
                {children}
            </View>
        </TouchableOpacity>
    );
}

export function SSOAuthButtonText({provider}: {provider: SSO_PROVIDER}) {
    const {darkModeEnabled} = useCommunityTheme();
    const {authType} = useGetAuthType();
    const isLogin = authType === AUTH_TYPE.LOGIN;

    return (
        <Text
            style={{
                ...styles.ButtonText,
                ...Platform.select({
                    android: {
                        fontFamily: "Roboto Medium",
                    },
                }),
                color: darkModeEnabled ? "white" : "#1f1f1f",
            }}
        >
            Sign {isLogin ? "in" : "up"} with{" "}
            <Text style={{textTransform: "capitalize"}}>{provider}</Text>
        </Text>
    );
}

const styles = StyleSheet.create({
    Button: {
        width: "100%",
        borderWidth: 1,
        borderRadius: 4,
        paddingHorizontal: 8,
    },
    ButtonContentWrapper: {
        height: 42,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    },
    Icon: {
        flexShrink: 0,
    },
    ButtonText: {
        fontFamily: "Roboto",
        fontWeight: "500",
        fontSize: 14,
        letterSpacing: 0.25,
        marginLeft: 12,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});
